import { render } from "./video-index.vue?vue&type=template&id=43336304"
import script from "./video-index.vue?vue&type=script&lang=js"
export * from "./video-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__